import React from 'react';
import {Button} from '../../componentsFormV2';
import DateInput from '~components/DateInput';
import {
    Footer,
    FormFooter,
    FormWrapper,
    HeaderCookies,
    HeaderLogoMenu,
    HeaderTitleAndVersion,
    MainWrapper,
} from '../../componentsLayout';
import HeaderLoading from '~shared/HeaderLoading';
import NavigationVarietyFinder from '../../shared/NavigationVarietyFinder';
import SelectInput from '~components/SelectInput';
import TextInput from '~components/TextInput';
import graphQLClientInstance from '../../utils/axiosGraphQLClient';
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import {trackPageView} from '../../utils';

interface IProps {
    intl: any;
    history: any;
}

interface IState {
    dateInputDecisionDateFrom: string;
    dateInputDecisionDateTo: string;
    selectInputArticleValue: string;
    selectInputSubHeadingValue: string;
    selectInputOutcomeValue: string;
    textInputDenominationValue: string;
    textInputKeywordInDecisionValue: string;
    loading: number;
    screenLoaded: boolean;
}

class VFJurisprudence extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            dateInputDecisionDateFrom: '',
            dateInputDecisionDateTo: '',
            selectInputArticleValue: '',
            selectInputSubHeadingValue: '',
            selectInputOutcomeValue: '',
            textInputDenominationValue: '',
            textInputKeywordInDecisionValue: '',
            loading: 0,
            screenLoaded: false,
        };
    }

    componentDidMount() {
        trackPageView({documentTitle: 'Jurisprudence'});
        this.loadJSONs();
    }

    loadJSONs() {
        this.setState(
            prev => ({loading: prev.loading + 1}),
            () => {
                Promise.all([
                    graphQLClientInstance.post('/api/v1/graphql', {
                        query: `
                        {
                          jurisprudencepre {
                            data {
                              key
                              subheadings
                            } total
                          }
                        }`,
                    }),
                ]).then(([JSONResponseJurisprudence]: any) => {
                    console.log(JSONResponseJurisprudence, 'JSONResponseJurisprudence');
                    this.setState(prev => ({loading: prev.loading - 1}));
                });
            }
        );
    }

    onHeaderSearchLinkClick = (searchListItem: any) =>
        this.props.history.push({
            pathname: '/varieties',
            state: {searchListItem},
        });

    search() {}

    resetCriteria() {}

    onLinkButtonHelpClick = () => window.open('/help/en/Jurisprudence_help.html', '_blank');

    onLinkButtonDisclaimerClick = () => window.open('/help/en/Jurisprudence_disclaimer.html', '_blank');

    onSelectInputArticleChange = (value: any) => {
        console.log(value, 'value');
    };

    onSelectInputSubHeadingChange = (value: any) => {
        console.log(value, 'value');
    };

    onSelectInputOutcomeChange = ({target: {value: selectInputOutcomeValue}}: React.ChangeEvent<HTMLSelectElement>) =>
        this.setState({selectInputOutcomeValue});

    onTextInputDenominationChange = ({
        target: {value: textInputDenominationValue},
    }: React.ChangeEvent<HTMLInputElement>) => this.setState({textInputDenominationValue});

    onTextInputKeywordInDecisionChange = ({
        target: {value: textInputKeywordInDecisionValue},
    }: React.ChangeEvent<HTMLInputElement>) => this.setState({textInputKeywordInDecisionValue});

    onDateInputDecisionDateFromChange = (dateInputDecisionDateFrom: string) =>
        this.setState({dateInputDecisionDateFrom});

    onDateInputDecisionDateToChange = (dateInputDecisionDateTo: string) => this.setState({dateInputDecisionDateTo});

    render() {
        return (
            <>
                {this.state.loading ? <HeaderLoading /> : null}
                <HeaderCookies />
                <HeaderLogoMenu />
                <HeaderTitleAndVersion title={`Variety Finder | Jurisprudence`} />
                <NavigationVarietyFinder onSearchLinkClick={this.onHeaderSearchLinkClick} />
                <MainWrapper>
                    <FormWrapper formInnerWidth={'lg'} paddingFormContent={'sm'}>
                        <SelectInput
                            label={`Article`}
                            value={this.state.selectInputArticleValue}
                            onChange={this.onSelectInputArticleChange}
                            list={[]}
                            size={'lg'}
                        />
                        <SelectInput
                            label={`SubHeading`}
                            value={this.state.selectInputSubHeadingValue}
                            onChange={this.onSelectInputSubHeadingChange}
                            list={[]}
                            double={true}
                            size={'lg'}
                        />
                        <SelectInput
                            label={`Outcome`}
                            value={this.state.selectInputOutcomeValue}
                            onChange={this.onSelectInputOutcomeChange}
                            list={[
                                {id: 'All', value: 'All'},
                                {id: 'suitable', value: 'Suitable'},
                                {id: 'not suitable', value: 'Not Suitable'},
                            ]}
                            notAll={true}
                            size={'lg'}
                        />
                        <TextInput
                            label={`Denomination`}
                            value={this.state.textInputDenominationValue}
                            onChange={this.onTextInputDenominationChange}
                            double={true}
                            size={'lg'}
                        />
                        <DateInput
                            label={'Decision Date'}
                            changeDateFrom={this.onDateInputDecisionDateFromChange}
                            changeDateTo={this.onDateInputDecisionDateToChange}
                            inputValueFrom={this.state.dateInputDecisionDateFrom}
                            inputValueTo={this.state.dateInputDecisionDateTo}
                            size={'lg'}
                        />
                        <TextInput
                            label={`Keyword in decision`}
                            value={this.state.textInputKeywordInDecisionValue}
                            onChange={this.onTextInputKeywordInDecisionChange}
                            double={true}
                            size={'lg'}
                        />
                        <div style={{clear: 'both'}} />
                        <FormFooter>
                            <Button
                                clickAction={this.onLinkButtonDisclaimerClick}
                                variation={'secondary'}
                            >{`Disclaimer`}</Button>
                            <Button clickAction={this.onLinkButtonHelpClick} variation={'secondary'}>{`Help`}</Button>
                            <Button clickAction={this.resetCriteria} variation={'secondary'}>{`Clear fields`}</Button>
                            <Button clickAction={() => this.search()}>{`Search`}</Button>
                        </FormFooter>
                    </FormWrapper>
                </MainWrapper>
                <Footer hostApplication={'Variety Finder'} />
            </>
        );
    }
}

export default withRouter(injectIntl(VFJurisprudence));
